import { Modal } from "antd";
import { jobTypes } from "../../../../utils/data";
import { pipViewDate2 } from "../../../../utils/pip";

const FreelancerDetails = ({ isModal, setIsModal, data }) => {
  const jobLabel =
    jobTypes.find((opt) => opt.value === data?.job_type)?.label || "";
  const splitList = (value) => {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (!value) return [];
    return String(value)
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  };
  const portfolioLinks = splitList(data?.sample_portfolio_link);
  const preferredProjectTypes = splitList(data?.preferred_project_type);
  const toolsUsed = splitList(data?.tools_software_used);
  const parseMaybeArray = (value, fallback = []) => {
    if (Array.isArray(value)) return value;
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) return fallback;
      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? parsed : fallback;
      } catch {
        return [trimmed];
      }
    }
    return fallback;
  };
  const normalizeDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toISOString().slice(0, 10);
  };
  const normalizeCertificates = (value) => {
    const certificates = parseMaybeArray(value, []);
    return certificates
      .map((item, idx) => {
        if (!item || typeof item === "string") {
          const title =
            typeof item === "string"
              ? item
                  .split("/")
                  .pop()
                  ?.replace(/\.[^.]+$/, "")
                  .replace(/[-_]+/g, " ")
                  .trim() || `Certificate ${idx + 1}`
              : "";
          return {
            id: idx,
            title,
            location: "",
            start_date: "",
            end_date: "",
          };
        }
        return {
          ...item,
          id: item?.certificate_id || item?.id || item?.certificateId || idx,
          title: String(item?.title || item?.name || "").trim(),
          location: String(item?.location || item?.description || "").trim(),
          start_date: normalizeDate(item?.start_date),
          end_date: normalizeDate(item?.end_date),
        };
      })
      .filter(
        (item) =>
          item?.title || item?.location || item?.start_date || item?.end_date
      );
  };
  const formatCertificatePeriod = (startDate, endDate) => {
    if (!startDate && !endDate) return "";
    const startLabel = startDate ? pipViewDate2(startDate) : "N/A";
    const endLabel = endDate ? pipViewDate2(endDate) : "N/A";
    return `${startLabel} - ${endLabel}`;
  };
  const getCertificateDuration = (startDate, endDate) => {
    if (!startDate || !endDate) return "";
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) {
      return "";
    }

    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();
    let days = end.getDate() - start.getDate();

    if (days < 0) {
      months -= 1;
    }

    if (months < 0) {
      years -= 1;
      months += 12;
    }

    const parts = [];
    if (years > 0) {
      parts.push(`${years} ${years === 1 ? "Year" : "Years"}`);
    }
    if (months > 0) {
      parts.push(`${months} ${months === 1 ? "Month" : "Months"}`);
    }
    return parts.join(" ");
  };
  const certificateItems = normalizeCertificates(data?.certificates);

  const FileView = ({ label, list }) => {
    return (
      <>
        <div className="mt-3">
          <p className="ct_fs_16 mb-1">{label}</p>
          <div className="ct_multiple_img_div ct_custom_scroll d-flex gap-3 mt-3">
            {list?.length > 0 &&
              list?.map((item, ind) =>
                item.toLowerCase().includes(".pdf") ? (
                  <>
                    <div
                      className="position-relative ct_iframe_hover  "
                      style={{ width: "120px", height: "120px" }}
                    >
                      <iframe
                        src={item}
                        loading="lazy"
                        style={{
                          width: "120px",
                          height: "120px",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                      ></iframe>
                      <a
                        href={item}
                        target="_blank"
                        className="ct_pdf_full_view"
                      >
                        <i className="fa-solid fa-eye ct_cursor_pointer text-white"></i>
                      </a>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="position-relative ct_iframe_hover  "
                      style={{ width: "120px", height: "120px" }}
                    >
                      <div className="ct_document_uploaded_img">
                        <img
                          src={item || ""}
                          alt=""
                          style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "cover",
                            borderRadius: "10px",
                          }}
                        />
                      </div>
                      <a
                        href={item}
                        target="_blank"
                        className="ct_pdf_full_view"
                      >
                        <i className="fa-solid fa-eye ct_cursor_pointer text-white"></i>
                      </a>
                    </div>
                  </>
                )
              )}
          </div>
        </div>
      </>
    );
  };
  return (
    <Modal
      className=""
      visible={isModal}
      onCancel={() => {
        setIsModal(false);
      }}
      centered={true}
      footer={null}
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body px-4 pb-5">
            <div>
              <h4 class="mb-1 ct_fs_20">Freelancer Details</h4>
              {/* <p class="mb-0 ct_grey_text">
                See full details for this newly registered user
              </p> */}
            </div>
            <div class="d-flex align-items-start gap-3 justify-content-between mt-4 px-4 ct_flex_col_991 pb-3">
              <div class="d-flex align-items-center gap-3">
                <img
                  src={data?.profile_image || "/assets/img/user_profile.png"}
                  class="ct_img_56"
                />
                <div>
                  <h5 class="ct_fs_18 ct_fw_600 mb-1 me-1">
                    {data?.full_name ||
                      `${data?.first_name || ""} ${data?.last_name || ""}`.trim()}
                    {/* <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.27887 0.758426C7.18692 0.611517 7.05147 0.496929 6.89135 0.430612C6.73123 0.364295 6.55442 0.349549 6.38553 0.388426L5.18686 0.663759C5.06402 0.691993 4.93637 0.691993 4.81353 0.663759L3.61486 0.388426C3.44597 0.349549 3.26917 0.364295 3.10905 0.430612C2.94893 0.496929 2.81347 0.611517 2.72153 0.758426L2.0682 1.80109C2.00153 1.90776 1.91153 1.99776 1.80486 2.06509L0.762198 2.71843C0.615543 2.81029 0.501123 2.94552 0.434821 3.10537C0.368518 3.26521 0.353621 3.44173 0.392198 3.61043L0.667531 4.81043C0.695664 4.93305 0.695664 5.06046 0.667531 5.18309L0.392198 6.38243C0.353471 6.55122 0.368293 6.72788 0.434603 6.88786C0.500913 7.04784 0.615417 7.18319 0.762198 7.27509L1.80486 7.92843C1.91153 7.99509 2.00153 8.08509 2.06886 8.19176L2.7222 9.23443C2.9102 9.53509 3.26886 9.68376 3.61486 9.60443L4.81353 9.32909C4.93637 9.30086 5.06402 9.30086 5.18686 9.32909L6.3862 9.60443C6.55499 9.64315 6.73166 9.62833 6.89164 9.56202C7.05162 9.49571 7.18696 9.38121 7.27887 9.23443L7.9322 8.19176C7.99887 8.08509 8.08886 7.99509 8.19553 7.92843L9.23886 7.27509C9.38565 7.18306 9.5001 7.04756 9.5663 6.88745C9.63249 6.72734 9.64714 6.55058 9.6082 6.38176L9.33353 5.18309C9.3053 5.06025 9.3053 4.9326 9.33353 4.80976L9.60887 3.61043C9.64766 3.4417 9.63293 3.26509 9.56675 3.10511C9.50056 2.94514 9.38619 2.80975 9.23953 2.71776L8.1962 2.06443C8.08968 1.99764 7.99965 1.90761 7.93287 1.80109L7.27887 0.758426ZM6.94353 3.50976C6.98477 3.43394 6.99498 3.34508 6.97203 3.26187C6.94908 3.17867 6.89475 3.10762 6.82048 3.06365C6.7462 3.01969 6.65777 3.00626 6.57379 3.02617C6.48981 3.04608 6.41683 3.0978 6.3702 3.17043L4.62686 6.12109L3.5742 5.11309C3.54297 5.08103 3.5056 5.05558 3.46433 5.03827C3.42305 5.02096 3.37871 5.01213 3.33395 5.01233C3.28919 5.01252 3.24493 5.02173 3.2038 5.0394C3.16268 5.05707 3.12553 5.08285 3.09459 5.11518C3.06364 5.14752 3.03952 5.18576 3.02367 5.22762C3.00782 5.26948 3.00056 5.3141 3.00233 5.35883C3.0041 5.40355 3.01485 5.44746 3.03396 5.48794C3.05306 5.52842 3.08013 5.56463 3.11353 5.59443L4.46953 6.89376C4.50582 6.92846 4.54949 6.95452 4.59726 6.96998C4.64504 6.98544 4.69568 6.98991 4.74543 6.98305C4.79517 6.97619 4.84272 6.95818 4.88453 6.93037C4.92633 6.90255 4.96132 6.86565 4.98686 6.82243L6.94353 3.50976Z"
                        fill="#FFB703"
                      />
                    </svg> */}
                  </h5>
                </div>
                <div></div>
              </div>
            </div>
            <ul>
              {data?.location && (
                <li class="d-flex align-items-center gap-2 mb-2">
                  <img src="/assets/img/tdesign_location-filled.svg" alt="" />
                  <span> {data?.location || ""}</span>
                </li>
              )}

              <li class="d-flex align-items-center gap-2 mb-2">
                <img src="/assets/img/mail_icon_345.svg" alt="" />
                <span>{data?.email || "#N/A"}</span>
              </li>
              {data?.phone_number && (
                <li class="d-flex align-items-center gap-2 mb-2">
                  <img src="/assets/img/phone_789.svg" alt="" />
                  <span>
                    <strong class="ct_fw_600">Phone Number:</strong>{" "}
                    {data?.phone_number || "#N/A"}
                  </span>
                </li>
              )}
              {data?.country && (
                <li>
                  <strong class="ct_fw_600">Country :</strong>{" "}
                  <span class="">{data?.country}</span>
                </li>
              )}
              {data?.state && (
                <li>
                  <strong class="ct_fw_600">State :</strong>{" "}
                  <span class="">{data?.state}</span>
                </li>
              )}
              {data?.city && (
                <li>
                  <strong class="ct_fw_600">City :</strong>{" "}
                  <span class="">{data?.city}</span>
                </li>
              )}
              {data?.address_1 && (
                <li>
                  <strong class="ct_fw_600">Address 1 :</strong>{" "}
                  <span class="">{data?.address_1}</span>
                </li>
              )}
              {data?.address_2 && (
                <li>
                  <strong class="ct_fw_600">Address 2 :</strong>{" "}
                  <span class="">{data?.address_2}</span>
                </li>
              )}
              {data?.zip_code && (
                <li>
                  <strong class="ct_fw_600">Zip Code :</strong>{" "}
                  <span class="">{data?.zip_code}</span>
                </li>
              )}
              <li>
                <strong class="ct_fw_600">Role :</strong>{" "}
                <span class="">{data?.primary_role || ""}</span>
              </li>
              <li>
                <strong class="ct_fw_600">Talent Type :</strong>{" "}
                <span class="">
                  {data?.talent_type == "FREELANCER" ? "Freelancer" : "Job Seeker"}
                </span>
              </li>
              {data?.language && (
                <li>
                  <strong class="ct_fw_600">Language :</strong>{" "}
                  <span class="">{data?.language}</span>
                </li>
              )}
              {data?.gender && (
                <li>
                  <strong class="ct_fw_600">Gender :</strong>{" "}
                  <span class="">{data?.gender}</span>
                </li>
              )}
              {data?.dob && (
                <li>
                  <strong class="ct_fw_600">DOB :</strong>{" "}
                  <span class="">{data?.dob}</span>
                </li>
              )}
              {data?.time_zone && (
                <li>
                  <strong class="ct_fw_600">Time Zone :</strong>{" "}
                  <span class="">{data?.time_zone}</span>
                </li>
              )}
              {jobLabel && (
                <li>
                  <strong class="ct_fw_600">Job Type :</strong>{" "}
                  <span class="">{jobLabel}</span>
                </li>
              )}
              {data?.primary_role && (
                <li>
                  <strong class="ct_fw_600">Primary Role :</strong>{" "}
                  <span class="">{data?.primary_role}</span>
                </li>
              )}
              {data?.years_of_experience && (
                <li>
                  <strong class="ct_fw_600">Years of Experience :</strong>{" "}
                  <span class="">{data?.years_of_experience}</span>
                </li>
              )}
              {data?.availability && (
                <li>
                  <strong class="ct_fw_600">Availability :</strong>{" "}
                  <span class="">{data?.availability}</span>
                </li>
              )}
              {data?.hourly_rate && (
                <li>
                  <strong class="ct_fw_600">Hourly Rate :</strong>{" "}
                  <span class="">{data?.hourly_rate}</span>
                </li>
              )}
              {data?.website_or_portfolio && (
                <li>
                  <strong class="ct_fw_600">Portfolio or Website :</strong>{" "}
                  <span class="">{data?.website_or_portfolio}</span>
                </li>
              )}
              {data?.linkedin_profile && (
                <li>
                  <strong class="ct_fw_600">LinkedIn Profile :</strong>{" "}
                  <span class="">{data?.linkedin_profile}</span>
                </li>
              )}
              {data?.skills && (
                <li>
                  <strong class="ct_fw_600">Skills :</strong>{" "}
                  <span>{data?.skills}</span>
                </li>
              )}
              {toolsUsed.length > 0 && (
                <li>
                  <strong class="ct_fw_600">Tools & Software :</strong>{" "}
                  <span>{toolsUsed.join(", ")}</span>
                </li>
              )}
              {data?.search_status && (
                <li>
                  <strong class="ct_fw_600">Job Search Status :</strong>{" "}
                  <span>
                    {data?.search_status == "WORKING"
                      ? "Currently Working on a Project"
                      : "Available Now"}
                  </span>
                </li>
              )}
              {data?.salary_preference && (
                <li>
                  <strong class="ct_fw_600">Salary Preferences :</strong>{" "}
                  <span>{data?.salary_preference}</span>
                </li>
              )}
              {preferredProjectTypes.length > 0 && (
                <li>
                  <strong class="ct_fw_600">Preferred Project Type :</strong>{" "}
                  <span>{preferredProjectTypes.join(", ")}</span>
                </li>
              )}
              {data?.currency && (
                <li>
                  <strong class="ct_fw_600">Currency :</strong>{" "}
                  <span>{data?.currency}</span>
                </li>
              )}
              {data?.information_confirmed !== null &&
                data?.information_confirmed !== undefined && (
                  <li>
                    <strong class="ct_fw_600">Information Accuracy:</strong>{" "}
                    <span>
                      {data?.information_confirmed
                        ? "Confirmed"
                        : "Not Confirmed"}
                    </span>
                  </li>
                )}
              {data?.agree_contact_opportunities !== null &&
                data?.agree_contact_opportunities !== undefined && (
                  <li>
                    <strong class="ct_fw_600">Contact Consent (NUVIO):</strong>{" "}
                    <span>
                      {data?.agree_contact_opportunities
                        ? "Agreed"
                        : "Not Agreed"}
                    </span>
                  </li>
                )}
              {data?.bio && (
                <div className="mt-3">
                  <p className="ct_fs_16 mb-1">Bio</p>
                  <p className="mb-0 ct_fs_14 ct_para_scroll ct_custom_scroll">
                    {data?.bio || "#N/A"}
                  </p>
                </div>
              )}
              {portfolioLinks.length > 0 && (
                <div className="mt-3">
                  <p className="ct_fs_16 mb-1">Work Sample Links</p>
                  <ul
                    className="ct_para_scroll ct_custom_scroll ct_documents_lists mt-2"
                    style={{ maxHeight: "160px" }}
                  >
                    {portfolioLinks.map((link, ind) => (
                      <li key={`portfolio-link-${ind}`}>
                        <p className="mb-0 d-flex align-items-center gap-2">
                          <i class="fa-solid fa-link"></i>
                          <span className="text-truncate ct_fs_14">{link}</span>
                        </p>
                        <p className="mb-0 ct_down_documents_icon">
                          <a href={link} target="_blank">
                            <i class="fa-solid fa-arrow-up-right-from-square"></i>
                          </a>
                        </p>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {data?.projects?.length > 0 && (
                <div className="mt-3">
                  <p className="ct_fs_16 mb-1">Uploaded Projects</p>
                  <ul
                    className="ct_para_scroll ct_custom_scroll ct_documents_lists mt-2"
                    style={{ maxHeight: "160px" }}
                  >
                    {data?.projects?.map((item, ind) => {
                      const fullFileName = item?.project_url?.split("/").pop();
                      const displayName = fullFileName?.split("-").pop();
                      return (
                        <li>
                          <p className="mb-0 d-flex align-items-center gap-2">
                            <i class="fa-regular fa-file-zipper"></i>
                            <span
                              className="text-truncate ct_fs_14"
                              style={{ width: "100px" }}
                            >
                              {displayName || ""}
                            </span>
                          </p>
                          <p className="mb-0 ct_down_documents_icon">
                            <a href={item?.project_url} download>
                              <i class="fa-solid fa-download"></i>
                            </a>
                          </p>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
              {(data?.why_join_nuvio || data?.how_hear_about_nuvio) && (
                <div className="mt-3">
                  {data?.why_join_nuvio && (
                    <>
                      <p className="ct_fs_16 mb-1">Why Join Nuvio</p>
                      <p className="mb-0 ct_fs_14 ct_para_scroll ct_custom_scroll">
                        {data?.why_join_nuvio}
                      </p>
                    </>
                  )}
                  {data?.how_hear_about_nuvio && (
                    <>
                      <p className="ct_fs_16 mb-1 mt-3">How Heard About Nuvio</p>
                      <p className="mb-0 ct_fs_14 ct_para_scroll ct_custom_scroll">
                        {data?.how_hear_about_nuvio}
                      </p>
                    </>
                  )}
                </div>
              )}
              {data?.clients_types && (
                <div className="mt-3">
                  <p className="ct_fs_16 mb-1">Client Types</p>
                  <p className="mb-0 ct_fs_14 ct_para_scroll ct_custom_scroll">
                    {data?.clients_types}
                  </p>
                </div>
              )}
              {/* {data?.subscriptions?.length > 0 && (
                <div className="mt-3">
                  <p className="ct_fs_16 mb-1">Subscriptions</p>
                  <ul
                    className="ct_para_scroll ct_custom_scroll ct_documents_lists mt-2"
                    style={{ maxHeight: "160px" }}
                  >
                    {data?.subscriptions?.map((sub, ind) => (
                      <li key={`sub-${ind}`}>
                        <p className="mb-0 d-flex align-items-center gap-2">
                          <i class="fa-regular fa-bookmark"></i>
                          <span className="text-truncate ct_fs_14">
                            {sub?.title || "Subscription"}
                          </span>
                        </p>
                        <p className="mb-0 ct_fs_12">
                          {sub?.purchase_date || ""}{" "}
                          {sub?.expiry_date ? `- ${sub?.expiry_date}` : ""}
                        </p>
                      </li>
                    ))}
                  </ul>
                </div>
              )} */}
            </ul>
            {data?.cv?.length > 0 &&
              <FileView label="Resume" list={data?.cv || []} />
            }
            {certificateItems.length > 0 && (
              <div className="mt-3">
                <p className="ct_fs_16 mb-1">Certificate</p>
                <div className="ct_certification_list mt-2">
                  {certificateItems.map((item, index) => (
                    <div className="ct_certification_item" key={`certificate-${item.id || index}`}>
                      <div className="ct_certification_icon">
                        <i className="fa-solid fa-graduation-cap"></i>
                      </div>
                      <div className="ct_certification_body">
                        <div className="ct_certification_text">
                          <h5 className="ct_fs_16 mb-0 ct_darkblue_text ct_certification_title">
                            {item?.title || `Certificate ${index + 1}`}
                          </h5>
                          {item?.location && (
                            <p className="ct_fs_14 ct_darkblue_text mb-1 mt-2">
                              {item.location}
                            </p>
                          )}
                          <div className="d-flex align-items-center gap-4 flex-wrap mt-2">
                            {(item?.start_date || item?.end_date) && (
                              <p className="ct_fs_14 ct_grey_text mb-0">
                                {formatCertificatePeriod(item.start_date, item.end_date)}
                              </p>
                            )}
                            {getCertificateDuration(item.start_date, item.end_date) && (
                              <p className="ct_fs_14 ct_grey_text mb-0">
                                {getCertificateDuration(item.start_date, item.end_date)}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FreelancerDetails;
